import React from 'react'
import propTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Field, FieldArray } from 'formik'
import get from 'lodash/get'

import RepeatableAction from '../RepeatableAction'
import { Autocomplete, Dropdown } from '../Autocomplete'

const createEmptyLanguageObject = () => ({
  id: '',
  languageToUser: { languageId: '', languageProficiencyId: '' }
})

const handleLanguageChange = (language, form, index) => {
  if (language) {
    form.setFieldValue(`languages[${index}].id`, language.id, false)
    form.setFieldValue(`languages[${index}].name`, language.name, false)
    form.setFieldValue(
      `languages[${index}].languageToUser.languageId`,
      language.id,
      false
    )
  } else {
    form.setFieldValue(`languages[${index}].id`, '', false)
    form.setFieldValue(`languages[${index}].name`, '', false)
    form.setFieldValue(
      `languages[${index}].languageToUser.languageId`,
      '',
      false
    )
  }
}

const LanguageFields = ({ form, name, label, staticData }) => {
  const languageOptions = staticData.languages
  let languages = get(form.values, name)

  const availableLanguageOptions = languageOptions.map(languageOption => {
    const disabled = !!languages.find(
      language => languageOption.id === language.id
    )
    return { ...languageOption, disabled: disabled }
  })

  return (
    <div className='expert-form__input-group'>
      <label className='expert-form__label'>{label}</label>
      <div className='expert-form__input-wrapper'>
        <FieldArray
          name={name}
          render={arrayHelpers => (
            <div className='expert-form__repeatable-input-wrapper'>
              {languages.map((language, index) => (
                <div
                  className='expert-form__repeatable-input expert-form__repeatable-input--multiple'
                  key={index}
                >
                  <Field
                    valueIsId
                    data-cy='language-fields-language'
                    name={`${name}[${index}].id`}
                    placeholder=''
                    itemToString={item => item && item.name}
                    options={availableLanguageOptions}
                    onChange={value => handleLanguageChange(value, form, index)}
                    component={Autocomplete}
                  />
                  <Field
                    data-cy='language-fields-proficiency'
                    name={`${name}[${index}].languageToUser.languageProficiencyId`}
                    placeholder=' '
                    itemToString={item => item && item.name}
                    options={staticData.languageProficiencies}
                    component={Dropdown}
                  />
                  <RepeatableAction
                    fieldValues={languages}
                    arrayHelpers={arrayHelpers}
                    index={index}
                    initialObject={createEmptyLanguageObject()}
                  />
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </div>
  )
}

LanguageFields.propTypes = {
  form: propTypes.object.isRequired,
  name: propTypes.string.isRequired,
  label: propTypes.oneOfType([propTypes.string, propTypes.element]),
  staticData: propTypes.object
}

export default inject('staticData')(observer(LanguageFields))
